import React, { useState } from 'react';
import styled from 'styled-components'
// import { useHistory } from "react-router-dom";

import Card from '../reusable/Card'


const Community = ({ title, subtitle, text, index, active, toggleActive, background, color, logo, boxShadow }) => {
  // let history = useHistory();

  return(
    <Wrapper>
      <CardTranstions
      	cards={[
      		{
      			"title": "Exhibition space",
			      "subtitle": "Art portfolio, online shop",
			      "text": "Portfolio design is light and layout flexible, created to focus the attention on the art, adapt to every project individually and accommodate a wide variety of styles. Curate the exhibition, tell your unique story and sell your work directly to customers.",
            background:"#1F4AAD",
            logo:"#1F4AAD",
            color:"#fff",
            boxShadow:"inset 0px 0px 30px rgba(0, 0, 0, 0.2)",
      		},
      		{
      			"title": "Community",
			      "subtitle": "Discover & Explore page, Instagram Community",
			      "text": "Gathers students, alumni, uni staff and industry professionals all in one place. Get inspired, share experiences, discover art, collaborate and apply for work opportunities.",
            background:"#DC3C3A",
            logo:"#DC3C3A",
            color:"#fff",
            boxShadow:"inset 0px 0px 30px rgba(0, 0, 0, 0.2)",
      		},
      		{
      			"title": "Education",
			      "subtitle": "Workshops, webinars, video, e-book",
			      "text": "Carefully curated topics made to help you better understand the world of art and what it takes to make it big.",
            background:"#F7DA49",
            logo:"#F7DA49",
            color:"#000",
            boxShadow:"inset 0px 0px 30px rgba(0, 0, 0, 0.2)",
      		},
      		{
      			"title": "Business",
			      "subtitle": "Discover & Explore page",
			      "text": "Industry professionals can simply browse the Discover & Explore page, find students and their work and contact the university. Creating new and exciting collaboration opportunities. ",
            background:"#15181C",
            logo:"#23262A",
            color:"#fff",
            boxShadow:"inset 0px 0px 30px rgba(0, 0, 0, 0.5)",
      		}
      	]}
      />
    </Wrapper>
  )
}

const CardTranstions = ({ cards }) => {
  const [active, toggleActive] = useState(0);

  return(
    <WrapperInner background={cards[active].background}>
      {cards.map((item, index) => (
        <Card
          key={index}
          title={item.title}
          subtitle={item.subtitle}
          color={item.color}
          boxShadow={item.boxShadow}
          logo={item.logo}
          background={item.background}
          text={item.text}
          index={index}
          active={active}
          toggleActive={toggleActive}
        />
      ))}
    </WrapperInner>
  )
}

export default Community

const Wrapper = styled.div(props => ({
  paddingTop:108,
  minHeight:740,
  position:"realtive",
  width:"100%",
  height:"calc(100vh - 309px)",
  "@media (max-width: 650px)": {
    minHeight:640,
    paddingTop:72,
    height:"calc(100vh - 73px)",
  },
}));

const WrapperInner = styled.div(props => ({
  width:"100%",
  height:"100%",
  position:"relative",
  background: props.background,
}));
